import { endpoints } from 'utils/endpoints'
import { useQuery } from '@tanstack/react-query'
import axios from 'axios'
import { ApiKey } from 'features/incidents/components/enums'

/**
 * Makes a GET request to the endpoint that returns a list of countries.
 *
 * @returns A list of countries.
 */
export const getCountryList = async () => {
  const response = await axios.get(endpoints.getCountryList)
  return response.data
}

export const useGetCountries = () => {
  return useQuery([ApiKey.CountryList], () => getCountryList())
}
